import React from 'react';

import CheckboxWrapSC, { CheckboxSC } from './checkbox.styled';
import checkImg from '../../../assets/img/svg/check.svg';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import { SmallText } from '../../typography';
import classNames from 'classnames';
import Tooltip from '../tooltip/tooltip';

const Checkbox = (props) => {
  const {
    name,
    value,
    onChange,
    label,
    type,
    checked,
    hasError,
    linkSource,
    isModal,
    openModal,
    withInsideContent,
    children,
    bold,
    tooltipId,
    tooltipContentId,
    tooltipMinWidth,
    labelClassName,
  } = props;

  const openLink = (link) => {
    window.open(link, '_blank');
  };
  const classes = classNames('uppercase', {
    bold: bold,
    link: linkSource || isModal,
    [labelClassName]: labelClassName,
  });

  return (
    <CheckboxWrapSC>
      <CheckboxSC active={checked} type={type} hasError={hasError}>
        <input type="checkbox" value={value} name={name} checked={checked} onChange={onChange} />
        <div className="ch-circle">
          <img src={checkImg} alt="" />
        </div>
      </CheckboxSC>
      {linkSource ? (
        <span className={classes} onClick={() => openLink(linkSource)}>
          {' '}
          <FormattedMessage id={label} defaultMessage={dlt[`${label}`]} />
        </span>
      ) : isModal ? (
        <span onClick={() => openModal()} className={classes}>
          <FormattedMessage id={label} defaultMessage={dlt[`${label}`]} />
        </span>
      ) : withInsideContent ? (
        <SmallText className={classes}>{children}</SmallText>
      ) : (
        <SmallText className={classes}>
          <FormattedMessage id={label} defaultMessage={dlt[`${label}`]} />
        </SmallText>
      )}
      {tooltipContentId && (
        <Tooltip
          id={tooltipId}
          overlayInnerStyle={{ minWidth: tooltipMinWidth }}
          contentId={tooltipContentId}
        />
      )}
    </CheckboxWrapSC>
  );
};

Checkbox.defaultProps = {
  bold: true,
};

export default Checkbox;
